import { useState, useEffect, useContext } from 'react';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import churchForms from '../../../services/api/churchForms';
import { volunteersRowDef } from '../../../components/common/rows/volunteersRow';
import { Select, Input, Button } from 'semantic-ui-react';
import { changeDocTitle, conditionalList, searchSelectProps } from '../../../components/helpers';
import ReportButton from '../../../containers/admin/ReportButton';
import queryString from 'query-string';
import CreateVolunteer from '../../../containers/experience/volunteersLogs/VolunteerForm';
import AGTable from '../../../components/table/aggrid';
import { ListsContext } from '../../../services/contextProviders/lists/listsContext';
import { AdminTableSection, AdminTableContent } from 'src/assets/styles/components/AdminTable';

const AllVolunteers = (props) => {
  const [volunteers, set_volunteers] = useState([]);
  const [loading, set_loading] = useState(true);
  const [inputs, setInputs] = useState({});
  const [showImgs, set_showImgs] = useState(false);
  const [showNewVolunteerForm, set_showNewVolunteerForm] = useState(false);
  const [showVolunteerForm, set_showVolunteerForm] = useState(null);
  const [openVolLeaders, setOpenVolLeaders] = useState(null);
  const { churchMinistries, experienceVolunteersRoles, experienceVolunteersSections } =
    useContext(ListsContext);

  let query = props.location.search;
  let parsedQueryString = queryString.parse(query);

  useEffect(
    () => getInfo(),
    [inputs.serviceArea, inputs.volunteerRole, inputs.volunteerSection, inputs.showDeleted]
  );

  useEffect(() => {
    changeDocTitle(inputs.showDeleted ? 'Voluntarios Eliminados' : 'Voluntarios');
  }, [inputs.showDeleted]);

  const onEnter = (e) => {
    if (e.key === 'Enter') getInfo();
  };

  const serviceArea = inputs.serviceArea || '';
  const volunteerRole = inputs.volunteerRole || '';
  const volunteerSection = inputs.volunteerSection || '';

  function getInfo() {
    set_loading(true);

    let body = {
      keyword: inputs.keyword || parsedQueryString.keyword,
      volunteerRole,
      volunteerSection,
      showDeleted: !!inputs.showDeleted,
    };

    churchForms
      .getVolunteerForm({ body, serviceArea })
      .then((response) => {
        if (response.data.success) {
          set_loading(false);
          props.history.push('?keyword=');
          set_volunteers(response.data.volunteers);
        } else {
          set_loading(null);
        }
      })
      .catch((error) => {
        if (error.response) Swal.fire(error.response.data.message);
        set_loading(false);
      });
  }

  const selectHandle = (_event, { value, name }) => {
    setInputs((prev) => ({ ...prev, [name]: value }));
  };

  return (
    <AdminTableSection>
      <AdminTableContent>
        <div>
          <Button primary onClick={() => getInfo()}>
            Recargar
          </Button>
          <ReportButton
            URL={`/experience/VolunteersReport${serviceArea ? `/${serviceArea}` : ''}`}
            fileName={
              inputs.showDeleted
                ? 'reporte_voluntarios_eliminados.xlsx'
                : 'reporte_voluntarios.xlsx'
            }
            filters={{ showDeleted: !!inputs.showDeleted }}
            event="Descargar Reporte"
          />
          <Button
            primary={!!inputs.showDeleted}
            onClick={() => setInputs({ ...inputs, showDeleted: !inputs.showDeleted })}
          >
            {inputs.showDeleted ? 'Ver activos' : 'Ver eliminados'}
          </Button>
        </div>
        <Input
          loading={loading}
          name={'keyword'}
          onChange={(e) => setInputs({ ...inputs, keyword: e.target.value })}
          value={inputs.keyword}
          onKeyPress={onEnter}
          style={{ width: '45%' }}
          placeholder="Buscar..."
        />
        <Select
          placeholder="Selecciona el area para consultar."
          style={{
            display: 'inline-block',
            margin: ' 7px 0',
            width: '45%',
          }}
          loading={loading}
          {...searchSelectProps({
            name: 'serviceArea',
            handler: selectHandle,
            value: serviceArea,
            options: [
              { key: '', value: '', text: 'Todos' },
              ...churchMinistries.map((opt) => ({
                key: opt?.key,
                value: opt?.key,
                text: opt?.name,
              })),
            ],
          })}
        />
        <Select
          placeholder="Selecciona el rol para consultar."
          style={{
            display: 'inline-block',
            margin: ' 7px 0',
            width: '45%',
          }}
          loading={loading}
          {...searchSelectProps({
            name: 'volunteerRole',
            handler: selectHandle,
            value: volunteerRole,
            options: [
              { key: '', value: '', text: 'Todos' },
              ...experienceVolunteersRoles.map((opt) => ({
                key: opt?.key,
                value: opt?.key,
                text: opt?.name,
              })),
            ],
          })}
        />
        <Select
          placeholder="Selecciona la sección para consultar."
          style={{
            display: 'inline-block',
            margin: ' 7px 0',
            width: '45%',
          }}
          loading={loading}
          {...searchSelectProps({
            name: 'volunteerSection',
            handler: selectHandle,
            value: volunteerSection,
            options: [
              { key: '', value: '', text: 'Todos' },
              { key: 'Pendientes', value: 'Pendientes', text: 'Pendientes' },
              ...conditionalList(experienceVolunteersSections, inputs?.serviceArea).map((opt) => ({
                key: opt?.key,
                value: opt?.key,
                text: opt?.name?.replace(/_/g, ' '),
              })),
            ],
          })}
        />
      </AdminTableContent>
      <p>Total en pantalla: {volunteers.length}</p>
      <div>
        <Button primary onClick={() => set_showImgs(!showImgs)}>
          {showImgs ? 'Ocultar' : 'Mostrar'} fotos
        </Button>
        {!inputs.showDeleted && (
          <Button onClick={() => set_showNewVolunteerForm(true)}>Añadir un voluntario</Button>
        )}
        {showNewVolunteerForm && !inputs.showDeleted && (
          <CreateVolunteer
            mainInputs={inputs}
            getInfo={getInfo}
            set_loading={set_loading}
            loading={loading}
            set_showVolunteerForm={set_showNewVolunteerForm}
          />
        )}
      </div>

      <div>
        <AGTable
          rowData={volunteers}
          rowHeight={80}
          columnDefs={volunteersRowDef({
            setOpenVolLeaders,
            openVolLeaders,
            showVolunteerForm,
            set_showVolunteerForm,
            loading,
            set_loading,
            getInfo,
            showImgs,
            churchMinistries,
            showDeletedReason: !!inputs.showDeleted,
            showSubsection: /fundacion/i.test(volunteerSection),
          })}
          defaultCol={{
            suppressMovable: true,
          }}
        />
      </div>
    </AdminTableSection>
  );
};

export default AllVolunteers;
